export const getGoogleMapsUrl = (venue: any): string => {
  const address = venue.addressDisplay ?? venue.address;
  return (
    "https://www.google.com/maps/search/?api=1&query=" +
    encodeURIComponent(address)
  );
};
